import { AdGroupCashbackScopeColumnFactory } from '@bingads-webui-campaign/personalized-offer-columns';
import { InlineEditableSave } from './inline-editable/save';

export const AdGroupCashbackScopeColumn = AdGroupCashbackScopeColumnFactory({
  updater: InlineEditableSave,
});
